export const isMobile = () => {
  return window.innerWidth <= 768;
};

export const isDesktop = () => {
  return window.innerWidth >= 1024;
};

export const isLowDesktop = () => {
  return isDesktop() && window.innerHeight < 800;
};
